<template>
	<div id="recordsDashboard" class="row no-bottom-margin grey lighten-5">
		<!--  -->
	<div class="loader-container" v-if="!ready">
			<div 	class="preloader-wrapper small active">
			<div class="spinner-layer spinner-blue-only">
			<div class="circle-clipper left">
				<div class="circle"></div>
			</div><div class="gap-patch">
				<div class="circle"></div>
			</div><div class="circle-clipper right">
				<div class="circle"></div>
			</div>
			</div>
			</div>
		</div>

<!--  -->

		<div id="eStateHolder" v-else-if="records.length < 1 && ready">
			<empty-state
		:show-button="true">
				<template #header>{{timeOfDay}} {{user.name}}</template>
				<template #content>
					<div>
						You currently have no records in the list please select create a record below to begin
					</div>
				</template>
				<template #action>
          <router-link :to="{name:'new_record'}" class="btn-medium btn indigo accent-4 white-text">Create New Record</router-link>
				</template>
			</empty-state>
		</div>

<!--  -->

	<div class="row" v-else-if="currentRoute === 'records' || currentRoute === 'new_record'">
			<div class="col s12 site-max listing-view" >
				<div class="col s12">
					<search-field @search="$_searchFilter($event)" class="left" style="width: 100%"/>
					<div class="clear"></div>
				</div>

				<div class="col s12 no-padding">
					<div class="clear"></div>  
          <div class="col s3">
            <select-field
              class="left "
              :show-label="true"
              data-source="code"
							:currentValue="listFilter"
							:has-clear="true"
							clear-prop="All"
							@update="listFilter = $event.values"
              :data-options="recordType"
            >
						<span>Filter by</span>
						</select-field>
          </div>
          <div class="col s6 l3 right-align right">
						<router-link :to="{name:'new_record'}" class="btn rounded waves-effect white-text">
							<i class="material-icons-outlined left">add</i>
							add Record</router-link>
          </div>
        </div>
			<div class="tools">	
					<div class="col no-padding">
	
					</div>
				
					<div class="col pages-count">
						Viewing: {{searchResultsX.length > 1 ? `${searchResultsX.length} of ${pagination.totalItems}` : `${filteredRecords.length} of ${pagination.totalItems}`}} Entries
					</div>
					<div class="clear"></div>					
				</div>

				<div class="col s12 no-padding">
					<div class="headers col s12 items">
						<div class="item-col cbox">
					
								<label>
									<input type="checkbox" />
									<span>&nbsp;</span>
								</label>
					
						</div>
						<div class="item-col name">
							ID
						</div>
						<div class="from item-col">
							From
						</div>
						<div class="item-col type">
							<b>Type</b>
						</div>
						<div class="item-col subject">
							<b>Subject</b>
						</div>
						<div class="item-col date">
							<b>Date Stamped</b>
						</div>
					</div> 
					<div class="col s12 items" v-for="(record) in searchResultsX.length > 0 && this.searchFilter !== '' ? searchResultsX : filteredRecords" v-bind:key="record.id"	>
						<div class="show-on-hover">
							<button
								v-tipped
								data-tooltip="Delete"
								@click="$_deleteRecord(record.id)"
								class="btn-floating btn-small btn-flat waves-effect tooltipped">
								<i class="material-icons grey-text text-darken-1">delete</i>
							</button>
						</div>
						<div class="item-col cbox">
							<label>
								<input type="checkbox" />
								<span>&nbsp;</span>
							</label>
						</div>
						<div class="item-col name">
						<router-link :to="{name:'view_record',params:{id:record.id}}" class="grey-text text-darken-3">
							{{record.acf.name}}
						</router-link>
						</div> 
						<div class="from item-col">
							<!-- {{record.acf.from.first_name+' '+record.acf.from.last_name}} -->
							<router-link :to="{name:'view_record',params:{id:record.id}}" class="grey-text text-darken-3">
							{{$_matchUser(record.acf.from)}}
							</router-link>
						</div>
							<div class="item-col type">
							<span class="badge new" 
							v-bind:class="[record.acf.type.name === 'Incoming' ? 'green accent-4' : 'purple accent-4']"
							:data-badge-caption="record.acf.type.name"></span>
						</div>
						<div class="item-col subject">
							{{record.acf.subject}}
						</div>
	
						<div class="item-col date">
							{{$_formatDate(record.acf.date_stamp, 'MM/DD/YY')}}
						</div>
					</div>
					<div class="clear"></div>
					<div class="getTheRest center" style="margin-top: 16px;" v-if="records.length !== parseInt(pagination.totalItems)"> 
						<button :disabled="fetching" @click="$_getRecords(true)" class="btn waves-effect white grey-text text-darken-3 rounded">
							Load More
						</button>
					</div>
					<infinite-loading v-if="!fetching && shouldFetch" @infinite="$_getRecords(true)"> </infinite-loading> 
				</div>
			</div>
			<div class="col s12 l10">

			</div>
		</div>
	
		<div class="pickers" id="pickerContainer">
			
		</div>
		<!-- diglog  Modal -->
    <div class="dialog" ref="dialogComponent"></div>
    <!-- block list Modal -->
		<router-view />
	</div>
</template>
<script>


const debounce = (func, delay) => {
  let inDebounce
  return function () {
    const context = this
    const args = arguments
    clearTimeout(inDebounce)
    inDebounce = setTimeout(() =>
      func.apply(context, args), delay)
  }
}
import Fuse from 'fuse.js'
import InfiniteLoading from 'vue-infinite-loading'
import core from '@/functions'
import searchField from '@/components/searchField.component'
import dialogComponent from '@/components/dialog.component'
import contentService from '@/services/contentService'
import selectField from "@/components/editing/selectField.component"
import estate from '@/assets/estate.svg'
import Vue from 'vue'
import { mapState } from "vuex"
import moment from 'moment'
import emptyState from "@/components/emptyState.component";
export default {
	name: 'recordsView',
	components: {
		emptyState,
		selectField,
		searchField,
		InfiniteLoading,
		// eslint-disable-next-line vue/no-unused-components
		dialogComponent,
	},
	data() {
		return {

			searchEngine: null,
			searchResults:[],
			searchEngineConfig:{
        useExtendedSearch: true,
        shouldSort: true,
				findAllMatches: true,
				ignoreLocation: true,
				distance:200,
        keys: [
          'title.rendered',
					"acf.name",
          "acf.subject",
          "acf.notes",
          "acf.type.prop",
          "acf.category.prop",
          "acf.status",
					"fromP",
					"toP"
        ]
			},

			recordsSearch:'',
			fetching:false,
			shouldFetch:false,
			estate,
			listFilter:'All',
			recordType: {
				field_type: "inputField",
				icon: {
					active: false,
					value: "sort"
				},
				v: true,
				type: "select",
				label: "Filter by",
				values: "All",
				propName: "order_by",
				options: ["All", "Incoming", "Outgoing"]
			},
			perPage: {
				field_type: "inputField",
				icon: {
					active: false,
					value: "sort"
				},
				v: true,
				type: "select",
				label: "Per page",
				values: 20,
				propName: "per_page",
				options: [10,15,20,25,50,100]
			},
			tickets: [],
			newTicketStatus: "close",
			ready:false,
			totalPages: 1,
			
			pagination: {
        page: 1,
        per: 100,
				totalItems: 0,
				totalPages: 0,
      }
		};
	},
	mounted() {
		this.users.length < 1 
		? this.$_fetchUsers()
		: false
		this.companies.length < 1 
		? this.$_getCompanies()
		: false
		this.$_getRecords()
	},
	computed: {
		...mapState({
			user: state => state.user,
			authUser: state => state.authUser,
			records:state => state.record.records,
			users:state=> state.record.users,
			companies:state=> state.record.companies
		}),
		currentRoute:{
			get(){
				return this.$route.name
			}
		},
		timeOfDay: function() {
			let today = new Date();
			let curHr = today.getHours();
			if (curHr < 12) {
				return "Good Morning";
			} else if (curHr < 18) {
				return "Good Afternoon";
			} else {
				return "Good Evening";
			}
		},
		searchResultsX: {
			get () {
				let records = this.searchResults
				if (this.listFilter !== 'All') {
					return records.filter(x => x.acf.type.name === this.listFilter)
				} else {
					return records
				}
			}
		},
		filteredRecords:{
			get(){
			/* let records = this.records.filter(item => {
					return core.createFieldsText([
						item.acf.name,
						item.acf.date_stamp,
						item.acf.id,
						item.acf.subject,
						item.acf.notes,
						this.$_matchUser(item.acf.from),
						this.$_matchUser(item.acf.to),
						item.acf.date_corres,
						item.acf.type.name,
						])
						.toLowerCase()
						.includes(this.recordsSearch.replace(/  +/g, ' ').toLowerCase())
				}) */
				let records = this.records
				if (this.listFilter !== 'All') return records.filter(x => x.acf.type.name === this.listFilter).sort((a, b) => moment(new Date(b.date_stamp)).diff(moment(new Date(a.date_stamp))))
				else return records.sort((a, b) => moment(new Date(b.date_stamp)).diff(moment(new Date(a.date_stamp))))
						

							
			}
		}
	},
	watch:{
		$route:function(nV){
			if(nV && nV.name === 'records') {
			this.$_getRecords()
			this.$_getCompanies()
			this.$_fetchUsers()
			}
		
		},
		'records':function(){ 
			this.$_searchEngineInit()
		}
/* 		'pagination.page': function(){
			this.$_getRecords()
		} */
	},
	methods: {
		async $_searchEngineInit (){
			const newRecords = this.records.map(x => {
						let entry = x
						entry.fromP = this.$_matchUser(x.acf.from)
						entry.toP = this.$_matchUser(x.acf.to)
						return entry
			})
				return this.searchEngine = new Fuse(newRecords, this.searchEngineConfig)
		},
		$_setPage (/* $event */) {
	/* 		this.pagination.per = $event.values
			this.pagination.page = 1
			this.$_getRecords() */
		},
		$_searchFilter($event) {
			this.searchFilter = $event
			setTimeout(()=>{
					this.$_searchQuery(this.searchFilter)
			}, 100)
		},
		$_searchQuery:debounce(function(e){
		//	window.console.log(e)
			const search = async ()=> {return this.searchEngine.search(e)}
			search().then(x => {
					this.searchResults = x
					if(parseInt(this.pagination.totalItems) > this.records.length) this.$_getRecords(true)
		///		window.console.log(x)
			})
		}, 900),
		$_formatDate(date, format){
			return core.dateFormat(new Date(date), format)
		},
		$_getCompanies(){
			contentService.getRecordsCompanies()
			.then(res=>{
				this.$store.commit('SAVE_COMPANIES', res.data)
			})
			.catch(err=>{
				window.console.warn(err)
			})

		},
		dialogMessages(data) {
      let ComponentClass = Vue.extend(dialogComponent);
      let instance = new ComponentClass({
        propsData: data
      });
      let link = instance.$createElement("div", {
        attrs: {
          class: "context"
        },
        domProps: {
          innerHTML: data.message
        }
      });

      instance.$slots.default = [link];
      instance.$slots["title"] = [data.title];
      instance.$mount(); // pass nothing
      this.$refs.dialogComponent.appendChild(instance.$el);
    },
		$_deleteRecord(id){
		let data = {
				title:'Delete Record',
        message: "Are you sure you want to delete this record?",
        buttons: [
          {
            id: 0,
            value: "cancel",
            action: () => {},
            close: true
          },
   
          {
            id: 2,
            value: "Delete",
            action: () => {
						contentService.deleteRecord(id)
							.then(res=>{
								if(res.data.id){
									this.$store.commit('DELETE_RECORD', id)
									core.toastMessage('Successfully deleted record')
								}
							})
            },
            close: true
          }
        ]
      };
			this.dialogMessages(data);
		},
		$_fetchUsers(){
			contentService.getRecordsUsers()
			.then(res=>{
				this.$store.commit('SAVE_USERS', res.data)
			})
			.catch(err=>{
				window.console.warn(err)
			})
		},
		$_pagination(collection, page, per) {
			const customSort = (arr) =>{
				let order = this.listOrder 
				if(order === 'ID')
					return arr.sort((a, b) => parseInt(b.acf.id) - parseInt(a.acf.id))
				if(order === 'Date Stamp Desc')
					return arr.sort((a, b) => moment(new Date(b.acf.date_stamp)).diff(moment(new Date(a.acf.date_stamp))))
				if(order === 'Date Stamp Asc')
					return arr.sort((a, b) => moment(new Date(a.acf.date_stamp)).diff(moment(new Date(b.acf.date_stamp))))
			}
      !page ? (page = this.pagination.page) : false;
      !per ? (per = this.pagination.per) : false;
      if (!Array.isArray(collection)) {
        throw `Expect array and got ${typeof collection}`;
      }
      const currentPage = parseInt(page);
      const perPage = parseInt(per);
			const offset = (page - 1) * perPage;
				const collectionContainer = customSort(collection)
      const paginatedItems = collectionContainer.slice(offset, offset + perPage);
		
      return {
        currentPage,
        perPage,
        total: collection.length,
        totalPages: Math.ceil(collection.length / perPage),
        data: paginatedItems
      };
    },
		$_matchUser(id){
			const user =  this.users.find(user => user.id === id)
			return user ? user.acf.first_name+' '+user.acf.last_name : 'not a user'
		},
		$_getRecords(e){
				this.fetching = true
				let query = {per_page: this.pagination.per, page: e ? this.pagination.page + 1 : 1}
				contentService.getRecords(  query /* {per_page: this.pagination.per, page: this.pagination.page} */)
				.then(res=>{
				this.totalPages = parseInt(res.headers['x-wp-totalpages'])
					this.pagination.totalItems = res.headers['x-wp-total']
					this.pagination.totalPages = res.headers['x-wp-totalpages']
					this.ready = true
					if (parseInt(this.pagination.totalItems) === this.records.length) return
					this.pagination.page = query.page
			
					if(!e)	this.$store.commit('SAVE_RECORDS', res.data)
					else 	this.$store.commit('APPEND_RECORDS', res.data)

					this.shouldFetch = false
					this.fetching = false
					if (parseInt(this.pagination.totalPages) > 1 && this.pagination.page !== parseInt(this.pagination.totalPages)) {
						setTimeout(() => {
							this.shouldFetch = true
						}, 1000)
					}    

				})
				.catch(err=>{
					window.console.warn(err)
				})
			
		},
	}
};
</script>
<style scoped lang="scss">
div#recordsDashboard {
	min-height: 80vh;
	padding:24px;
	position: relative;
	@media screen and (min-width: 1024px) {
		width: calc(100% - 300px);
		margin-left: 300px;
	}
	#eStateHolder {
		left: 50%;
		top: 50%;
		position: absolute;
		transform: translate(-50%, -50%);
		@media screen and (min-width: 1024px) {
			transform: translate(calc(-50% + 150px), -50%);
		}
	}
	.title-section {
		font-size: 24px;
		line-height: 1.5;
		margin: 12px 0px 12px 0px;
	}
	.page-meta {
		transform: translateY(-16px);
		position: relative;
		&::after {
			content:'Correspondence Database';
			position: absolute;
			bottom:-16px;
			left:2px;
			font-size: 14px;
			letter-spacing: 1px;
		}
	}
	.items {
		width:100%;
		position: relative;
		box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0), 0px 4px 5px 0px rgba(0, 0, 0, 0), 0px 1px 10px 0px rgba(0, 0, 0, 0);
		cursor: pointer;
		display: inline-flex;
			&:hover{
				border:1px solid rgba(0,0,0,0.1);
				box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.02), 0px 4px 5px 0px rgba(0, 0, 0, 0.04), 0px 1px 10px 0px rgba(0, 0, 0, 0.02);
				transition: 200ms linear;
			}
		.item-col {
			margin-right:8px;
			&.cbox {
				width:26px;
			}
			&.name{
				width: 58px;
			}
			&.from {
				width: 180px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				font-weight: 500;
			}	
			&.subject {
				width:calc(100% - 450px);
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
			}
			&.type {
				width: 70px;
				position:relative;
				.badge {
					margin:0px;
					float:left
				}
			}
			&.date {
				font-weight: 500;
				@media screen and (min-width:768px) {
					position: absolute;
					right:15px;
				}
			}
		}
	}
	.items {
		padding:12px 12px;
		margin-bottom:0px;
		border: 1px solid transparent;
		border-bottom:1px solid rgba(0,0,0,0.1);
			.show-on-hover {
				position: absolute;
				right: 94px;
				background: white;
				margin-top: -4px;
				opacity: 0;
			}
		&:hover {
			.show-on-hover {
				opacity: 1;
			}
		}
	
	}

	#recordsSearch {
		box-shadow: none;
		border-radius: 22px;
		border: 1px solid rgba(0, 0, 0, 0.1);
		height: 32px;
		background: white;
		margin-top: 8px;
		padding: 0 12px 0px 34px;
		font-size: 13px;
		width: calc(100% - 48px);
	}
	.clearbtn {
    position: absolute;
    right: 9px;
    top: 16px;
    cursor: pointer;
			i {
        font-size: 18px;
      }
  }
	
	.tsc {
		position: relative;
		&::before {
			content: "search";
			font-family: "Material Icons";
			font-size: 21px;
			position: absolute;
			top: 10px;
			color: #8f8f8f;
			left: 12px;
		}
	}
	.circle-tar {
		border-radius:50%;
		width:50px;
		height:50px;
	}
button.btn.cs-btn {
    padding: 0px 4px;
    height: 30px;
    line-height: 29px;
    margin-right: 5px;
}
.loader-container {
		position: fixed;
		top:50%;
		left:50%;
		transform:translate(-50%,-50%);
			@media screen and (min-width:1024px){
				left:calc(50% + 300px);
				transform:translate(calc(-50% - 250px),-50%);
			}
	}
}
</style>
